export default __webpack_public_path__ + "static/media/dep1_4.f4253b45.png";